import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { createI18n } from 'vue-i18n';
import { SetupCalendar } from 'v-calendar';
import { createLx } from '@wntr/lx-ui';

import VueClickAway from 'vue3-click-away';
import App from '@/App.vue';
import router from '@/router';
import lv from '@/locales/lv.json';
import events from '@/router/events';
import 'cropperjs/dist/cropper.css'; // TODO Sergejs

import '@wntr/lx-ui/dist/styles/lx-reset.css';
import '@wntr/lx-ui/dist/styles/lx-fonts-carbon.css';
import '@wntr/lx-ui/dist/styles/lx-pt-carbon.css';
import '@wntr/lx-ui/dist/styles/lx-ut-carbon-light.css';

import '@wntr/lx-ui/dist/styles/lx-pt-viddis.css';

import '@wntr/lx-ui/dist/styles/lx-buttons.css';
import '@wntr/lx-ui/dist/styles/lx-data-grid.css';
import '@wntr/lx-ui/dist/styles/lx-inputs.css';
import '@wntr/lx-ui/dist/styles/lx-steps.css';
import '@wntr/lx-ui/dist/styles/lx-forms.css';
import '@wntr/lx-ui/dist/styles/lx-notifications.css';
import '@wntr/lx-ui/dist/styles/lx-modal.css';
import '@wntr/lx-ui/dist/styles/lx-loaders.css';
import '@wntr/lx-ui/dist/styles/lx-lists.css';
import '@wntr/lx-ui/dist/styles/lx-expanders.css';
import '@wntr/lx-ui/dist/styles/lx-tabs.css';
import '@wntr/lx-ui/dist/styles/lx-calendars.css';
import '@wntr/lx-ui/dist/styles/lx-animations.css';
import '@wntr/lx-ui/dist/styles/lx-master-detail.css';
import '@wntr/lx-ui/dist/styles/lx-ratings.css';

import '@wntr/lx-ui/dist/styles/lx-shell-grid.css';
import '@wntr/lx-ui/dist/styles/lx-shell-grid-public.css';
import '@wntr/lx-ui/dist/styles/lx-forms-grid.css';

import '@/styles/style.css';
import VueDOMPurifyHTML from 'vue-dompurify-html';

const myApp = createApp(App);
myApp.use(createPinia());
events(router);
myApp.use(router);
myApp.use(VueDOMPurifyHTML);

myApp.use(
  createI18n({
    locale: 'lv',
    messages: {
      lv,
    },
  })
);

myApp.use(SetupCalendar);
myApp.use(VueClickAway);
myApp.use(createLx, {
  systemId: 'viddis',
  authSessionKey: 'viddis-sessionkey',
  authUrl: window.config.authUrl,
  authClientId: 'viddis-auth',
  publicUrl: window.config.publicUrl,
});
myApp.mount('#app');
